import styled from '@emotion/styled';

export const Underlined = styled.span({
  textDecoration: 'underline',
});
